(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.TransportationController = (function(superClass) {
    extend(TransportationController, superClass);

    function TransportationController(scope, transitions, modal, http, service, state, _1, _2, _3, ngModal) {
      this.scope = scope;
      this.transitions = transitions;
      this.modal = modal;
      this.http = http;
      this.service = service;
      this.state = state;
      this.ngModal = ngModal;
      this.ginIsInList = bind(this.ginIsInList, this);
      this.getGinName = bind(this.getGinName, this);
      this.openSelectedGins = bind(this.openSelectedGins, this);
      this.loadStorageLocations = bind(this.loadStorageLocations, this);
      this.loadBuyerLocations = bind(this.loadBuyerLocations, this);
      this.loadSelectedGins = bind(this.loadSelectedGins, this);
      this.deleteLocation = bind(this.deleteLocation, this);
      this.editLocation = bind(this.editLocation, this);
      this.addLocation = bind(this.addLocation, this);
      this.calculateDistance = bind(this.calculateDistance, this);
      TransportationController.__super__.constructor.apply(this, arguments);
      this.selectedGins = [];
      this.service.onDataLoaded(this.scope, (function(_this) {
        return function() {
          _this.buyerLocation = _this.service.fpcResult.data.buyer_location;
          _this.loadSelectedGins().then(function() {
            return _this.loadBuyerLocations();
          })["catch"](function(err) {
            return _this.loadBuyerLocations();
          });
          _this.loadStorageLocations();
          return _this.scope.$watchGroup(['service.fpcResult.data.stored_on_farm', 'service.fpcResult.data.storage_location', 'service.fpcResult.data.delivered_to_buyer', 'service.fpcResult.data.buyer_location'], _this.calculateDistance);
        };
      })(this));
    }

    TransportationController.prototype.calculateDistance = function() {
      return this.http.post("backend/grower/fieldprint/" + this.service.fpcResult.id + "/calculate-distance", this.service.fpcResult.data).then((function(_this) {
        return function(response) {
          var ref;
          if (!response.data && (_this.service.fpcResult.data != null)) {
            _this.service.fpcResult.data.distance = null;
            return;
          }
          if (((ref = _this.service.fpcResult) != null ? ref.data : void 0) != null) {
            return _this.service.fpcResult.data.distance = parseFloat(response.data).toFixed(1);
          }
        };
      })(this));
    };

    TransportationController.prototype.addLocation = function(type) {
      this.service.save(this.service.fpcResult.id);
      if (type === 'buyer') {
        return this.state.go('grower.buyerlocation', {
          locationId: null,
          fpcResultId: this.service.fpcResult.id,
          step: this.service.currentStepIndex + 1
        });
      } else {
        return this.state.go('grower.operation.add-storage', {
          fpcId: this.service.fpcResult.id,
          fpcStep: this.service.currentStepIndex + 1
        });
      }
    };

    TransportationController.prototype.editLocation = function(type) {
      if (type === 'buyer') {
        return this.state.go('grower.buyerlocation', {
          locationId: this.service.fpcResult.data.buyer_location,
          fpcResultId: this.service.fpcResult.id,
          step: this.service.currentStepIndex + 1
        });
      } else {
        return this.http.get("backend/grower/storage-locations/" + this.service.fpcResult.data.storage_location).then((function(_this) {
          return function(response) {
            return _this.state.go('grower.operation.edit-storage', {
              storageLocation: response.data,
              fpcId: _this.service.fpcResult.id,
              fpcStep: _this.service.currentStepIndex + 1
            });
          };
        })(this));
      }
    };

    TransportationController.prototype.deleteLocation = function(type) {
      var dlg, newscope;
      newscope = this.scope.$new();
      newscope.item_name = (_.capitalize(type)) + " Location";
      newscope["delete"] = (function(_this) {
        return function() {
          if (type === 'buyer') {
            return _this.http.post('backend/grower/buyer-location/delete', {
              location: _this.service.fpcResult.data.buyer_location,
              fpcResultId: _this.service.fpcResult.id
            });
          } else {
            return _this.http.post('backend/grower/operation/delete-location', {
              locations: [
                {
                  id: _this.service.fpcResult.data.storage_location
                }
              ],
              fpcResultId: _this.service.fpcResult.id
            });
          }
        };
      })(this);
      dlg = this.modal.open({
        templateUrl: 'backend/portal/home/delete-dialog',
        controller: 'DeleteDialogController',
        scope: newscope
      });
      return dlg.result.then((function(_this) {
        return function() {
          if (type === 'buyer') {
            _this.service.fpcResult.data.buyer_location = null;
            return _this.loadBuyerLocations();
          } else {
            _this.service.fpcResult.data.storage_location = null;
            return _this.loadStorageLocations();
          }
        };
      })(this));
    };

    TransportationController.prototype.loadSelectedGins = function() {
      return this.http.get("backend/grower/selected-gin-lists?year=" + this.service.year + "&field_id=" + this.service.field).then((function(_this) {
        return function(response) {
          var ref;
          if (response.data.length === 0) {
            return;
          }
          _this.selectedGins = (ref = response.data[0]) != null ? ref.gins : void 0;
          if (_this.service.fpcResult.data.buyer_location && !_this.ginIsInList()) {
            return _this.http.get("backend/grower/api-gins/" + _this.service.fpcResult.data.buyer_location + "?year=" + _this.service.year + "&field_id=" + _this.service.field).then(function(response) {
              return _this.selectedGins.push(response.data);
            });
          }
        };
      })(this));
    };

    TransportationController.prototype.loadBuyerLocations = function() {
      return this.http.post('backend/grower/buyer-location/load-all', {
        fpcResultId: this.service.fpcResult.id
      }).then((function(_this) {
        return function(response) {
          var i, j, len, len1, location, ref, ref1, ref2, ref3;
          _this.buyerLocations = [];
          ref = response.data.data;
          for (i = 0, len = ref.length; i < len; i++) {
            location = ref[i];
            if (!location.deleted) {
              _this.buyerLocations.push(location);
            }
          }
          ref1 = response.data.data;
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            location = ref1[j];
            if (location.selected != null) {
              _this.service.fpcResult.data.buyer_location = location.id;
            }
          }
          if ((((ref2 = _this.service.fpcResult) != null ? ref2.data : void 0) != null) && (_this.service.fpcResult.data.buyer_location == null)) {
            if (_this.selectedGins.length === 1 && ((ref3 = _this.service.config[_this.service.crop].steps.value.Transportation.value.transportation.value.buyer_location.value.is_gin) != null ? ref3.value : void 0)) {
              return _this.service.fpcResult.data.buyer_location = _this.selectedGins[0].id;
            } else if (_this.buyerLocations.length === 1) {
              return _this.service.fpcResult.data.buyer_location = _this.buyerLocations[0].id;
            }
          }
        };
      })(this));
    };

    TransportationController.prototype.loadStorageLocations = function() {
      return this.http.get('backend/grower/operation/load-storage-locations').then((function(_this) {
        return function(response) {
          var ref;
          if (((ref = _this.service.fpcResult) != null ? ref.data : void 0) != null) {
            _this.storageLocations = response.data.data.filter(function(location) {
              return !location.is_manure;
            });
            if (_this.storageLocations.length === 1 && (_this.service.fpcResult.data.storage_location == null)) {
              return _this.service.fpcResult.data.storage_location = _this.storageLocations[0].id;
            }
          }
        };
      })(this));
    };

    TransportationController.prototype.openSelectedGins = function() {
      return this.ngModal.openSelectedGins(this.service.year, this.service.fpcResult.field).modalRef.result.then((function(_this) {
        return function(gins) {
          _this.selectedGins = gins;
          if (!_this.ginIsInList()) {
            return _this.service.fpcResult.data.buyer_location = null;
          }
        };
      })(this))["catch"](_.noop);
    };

    TransportationController.prototype.getGinName = function(gin) {
      var address, first, ref, second;
      if ((gin != null ? gin.name : void 0) == null) {
        return 'Loading...';
      }
      first = [gin.address, gin.city].filter(function(v) {
        return v;
      }).join(' ');
      second = [(ref = gin.county) != null ? ref.state.code : void 0, gin.zip].filter(function(v) {
        return v;
      }).join(' ');
      address = [first, second].filter(function(v) {
        return v;
      }).join(', ');
      return gin.name + " (" + (this.getStatusText(gin)) + ") (" + address + ")";
    };

    TransportationController.prototype.ginIsInList = function() {
      return this.selectedGins.some((function(_this) {
        return function(gin) {
          return gin.id === _this.service.fpcResult.data.buyer_location;
        };
      })(this));
    };

    TransportationController.prototype.getStatusText = function(gin) {
      switch (gin.status_type) {
        case 'not_connected':
          return 'Gin Not Connected';
        case 'connected':
          return 'Gin Connected';
        case 'connected_without_fields_available':
          return 'Gin Connected';
        case 'no_field_connected':
          return 'Gin Not Connected';
        case 'field_connected':
          return 'Field Connected';
        case 'pending_review':
          return 'Pending Review';
        case 'connection_na':
          return 'Connection N/A';
        default:
          return 'Connection N/A';
      }
    };

    return TransportationController;

  })(Controller);

}).call(this);
